import { useEffect } from "react";
import "./ExcluirDesvioEditarModal.css";

export default function ExcluirDesvioEditarModal({ open, label, onClose, onConfirm }) {
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  useEffect(() => {
    if (!open) return;
    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose?.();
      if (e.key === "Enter") onConfirm?.();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open, onClose, onConfirm]);

  if (!open) return null;

  return (
    <div className="dvexm-overlay" onMouseDown={(e) => e.target === e.currentTarget && onClose?.()}>
      <div className="dvexm-modal" role="dialog" aria-modal="true" aria-label="Excluir item">
        <header className="dvexm-header">
          <h3 className="dvexm-title">Excluir</h3>
          <button type="button" className="dvexm-close" aria-label="Fechar" onClick={onClose}>
            ×
          </button>
        </header>

        <div className="dvexm-body">
          Tem certeza que deseja <strong>excluir</strong> "{label || "este item"}"?
        </div>

        <footer className="dvexm-footer">
          <button type="button" className="dvexm-btn dvexm-btn--ghost" onClick={onClose}>
            Cancelar
          </button>
          <button type="button" className="dvexm-btn dvexm-btn--danger" onClick={onConfirm}>
            Excluir
          </button>
        </footer>
      </div>
    </div>
  );
}
